<template>
  <form class="form">
    <div class="row">
      <div class="col-xs-6">
        <div class="form__group">
          <input
            v-validate.disable="'required|alpha'"
            :value="user.firstName"
            @input="updateUserFirstName"
            class="form__input"
            id="firstName"
            name="fistName"
            type="text"
            placeholder="First Name">
          <label
            class="form__label"
            for="firstName">First Name <span class="form__error">{{ errors.first('fistName') }}</span></label>

        </div>
      </div>
      <div class="col-xs-6">
        <div class="form__group">
          <input
            v-validate.disable="'required|alpha'"
            :value="user.lastName"
            @input="updateUserLastName"
            class="form__input"
            name="lastName"
            id="lastName"
            type="text"
            placeholder="Last Name">
          <label
            class="form__label"
            for="lastName">Last Name <span class="form__error">{{ errors.first('lastName') }}</span></label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form__group">
          <input
            v-validate.disable="'required|email'"
            :value="user.email"
            @input="updateUserEmail"
            class="form__input"
            type="email"
            id="email"
            name="email"
            placeholder="Email">
          <label
            class="form__label"
            for="parentEmail">Email  <span class="form__error">{{ errors.first('email') }}</span></label>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-6">
            <div class="form__group">
              <input
                v-validate.disable="'required|alpha|min:2'"
                maxlength="2"
                :value="user.state"
                @input="updateUserState($event)"
                type="text"
                class="form__input"
                id="state"
                name="state"
                placeholder="State">
              <label
                class="form__label"
                for="state">State <span class="form__error">{{ errors.first('state') }}</span></label>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form__group">
              <input
                v-validate.disable="'required|alpha'"
                :value="user.city"
                @input="updateUserCity"
                class="form__input"
                type="text"
                id="city"
                name="city"
                placeholder="City">
              <label
                class="form__label"
                for="parentCity">City <span class="form__error">{{ errors.first('city') }}</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AboutYouForm',
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  methods: {
    ...mapActions([
      'updateUserFirstName',
      'updateUserLastName',
      'updateUserEmail',
      'updateUserState',
      'updateUserCity',
    ]),
  },
};
</script>

<style lang="sass">
</style>
